/**
 * UAT-43 (ciclo 1 de review, PR web#2337) — módulo-escopo real (não uma variável do
 * `<script setup>` de `AttendanceSheetCard.vue`, que é per-instância): com duas
 * `AttendanceSheetCard` montadas na mesma página, `handleShortcutKeyDown` precisa de um
 * jeito de saber QUAL das duas foi a última interagida, para não roubar o atalho da
 * outra (ou de um componente terceiro qualquer).
 *
 * Vive num `.ts` próprio, importado pelo `<script setup>`, em vez de um segundo bloco
 * `<script>` não-setup no mesmo SFC (a primeira tentativa, ciclo 1) — esse segundo bloco
 * quebrava o build de produção (`yarn build`, TS2306 `File '...AttendanceSheetCard.vue.ts'
 * is not a module`): dois blocos `<script>` no mesmo SFC exigem um `export default`
 * combinado, e como o bloco novo não exportava nada, o shim gerado pelo fork-ts-checker
 * para o `.vue` ficava sem módulo. Um arquivo `.ts` separado tem a mesma semântica de
 * módulo-escopo (compartilhado entre todas as instâncias do componente) sem tocar na
 * geração do shim do SFC.
 */
let lastActiveSheetGridContainer: HTMLElement | null = null

export function markSheetGridActive(container: HTMLElement) {
  lastActiveSheetGridContainer = container
}

export function isLastActiveSheetGrid(container: HTMLElement): boolean {
  return lastActiveSheetGridContainer === container
}

/**
 * Ciclo 2 de review — chamado no `destroyGrid` da grade: sem isso, o holder ficaria
 * retendo uma referência forte a um `HTMLElement` já desmontado (a checagem por
 * `isLastActiveSheetGrid` continuaria funcionando de qualquer forma, já que nenhum
 * listener resta para agir sobre ela, mas a referência presa é desnecessária).
 */
export function clearIfLastActiveSheetGrid(container: HTMLElement) {
  if (lastActiveSheetGridContainer === container) lastActiveSheetGridContainer = null
}
